import React from 'react';
import './index.scss';
import { Modal, Button } from 'antd';
import TranslateIconTrue from '@/images/icons/translate_icon_true.svg';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import { ReactComponent as CloseIcon } from '@/images/icons/close_modal.svg';
import { getIn18Text } from 'api';
const Img = React.createElement("img", { src: TranslateIconTrue, alt: "arrow-right" });
const TranslateModal = props => {
    const { visible, closeModal } = props;
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    return (React.createElement(Modal, { visible: visible, closable: true, centered: true, width: 452, title: getIn18Text('FANYIGONGNENGSHENG'), wrapClassName: "translate-modal", onCancel: closeModal, closeIcon: React.createElement(CloseIcon, { className: "dark-invert" }), footer: [
            React.createElement("span", { className: "footer-tip", style: { marginRight: '16px' } }, getIn18Text('QINGLIANXININDE')),
            React.createElement(Button, { key: "submit", type: "primary", size: "small", onClick: closeModal }, getIn18Text('ZHIDAOLE')),
        ] },
        React.createElement("div", { className: "translate-body" },
            React.createElement("div", { className: "translate-container" },
                React.createElement("div", { className: `name` },
                    React.createElement("div", { className: "item" }, getIn18Text('GONGNENGBANBEN')),
                    React.createElement("div", { className: "item" }, getIn18Text('ZHONGYINGWENHUYI')),
                    React.createElement("div", { className: "item" }, getIn18Text('ZIDONGSHIBIEYU')),
                    React.createElement("div", { className: "item" }, getIn18Text('SHOUDONGXUANZEFAN'))),
                React.createElement("div", { className: `product ${productVersionId === 'free' ? 'select' : ''}` },
                    React.createElement("div", { className: "productName" }, getIn18Text('MIANFEIBAN')),
                    React.createElement("div", { className: "item" }, Img),
                    React.createElement("div", { className: "item" }),
                    React.createElement("div", { className: "item" })),
                React.createElement("div", { className: `product ${productVersionId === 'ultimate' ? 'select' : ''}` },
                    React.createElement("div", { className: "productName" }, getIn18Text('QIJIANBAN')),
                    React.createElement("div", { className: "item" }, Img),
                    React.createElement("div", { className: "item" }, Img),
                    React.createElement("div", { className: "item" }, getIn18Text('FUFEI'))),
                React.createElement("div", { className: `product ${productVersionId === 'sirius' ? 'select' : ''}` },
                    React.createElement("div", { className: "productName" }, getIn18Text('ZUNXIANGBAN')),
                    React.createElement("div", { className: "item" }, Img),
                    React.createElement("div", { className: "item" }, Img),
                    React.createElement("div", { className: "item" }, Img))))));
};
export default TranslateModal;
